import { Card } from '@generated-types';

export const canBlock = ({ allowedOperations }: Card) => allowedOperations.softBlock || allowedOperations.hardBlock;
export const canSoftBlock = ({ allowedOperations }: Card) => allowedOperations.softBlock;
export const canHardBlock = ({ allowedOperations }: Card) => allowedOperations.hardBlock;
export const canReopen = ({ allowedOperations }: Card) => allowedOperations.unblock;
export const canReorder = ({ allowedOperations }: Card) => allowedOperations.hardBlock || allowedOperations.reorder;
export const canSetPin = ({ allowedOperations }: Card) => allowedOperations.setPin;
